var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 0.728516C10.4649 0.728516 13.2712 3.53481 13.2712 6.99935C13.2712 10.4639 10.4649 13.2702 7.00033 13.2702C3.53578 13.2702 0.729492 10.4639 0.729492 6.99935C0.729492 3.53481 3.53578 0.728516 7.00033 0.728516ZM7.00033 1.60352C4.01903 1.60352 1.60449 4.01806 1.60449 6.99935C1.60449 9.98064 4.01903 12.3952 7.00033 12.3952C9.98162 12.3952 12.3962 9.98064 12.3962 6.99935C12.3962 4.01806 9.98162 1.60352 7.00033 1.60352ZM6.12533 4.22852C6.2831 4.22852 6.43661 4.27969 6.56283 4.37435L9.28505 6.41602C9.60721 6.65764 9.67251 7.11468 9.43088 7.43685C9.38942 7.49212 9.34032 7.54123 9.28505 7.58268L6.56283 9.62435C6.24066 9.86597 5.78362 9.80068 5.54199 9.47852C5.46311 9.37334 5.41442 9.2492 5.40039 9.11944L5.39616 9.04102V4.95768C5.39616 4.55497 5.72262 4.22852 6.12533 4.22852ZM6.27116 5.24935V8.74935L8.60449 6.99935L6.27116 5.24935Z",
    fill: "#CACCCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.4869616fa7e30109b01ac79757d388d8.svg";
export { ForwardRef as ReactComponent };